import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { DataDefinitionDynamicColumn, DataDefinitionList } from '../../data-definition.model';

@Component({
  selector: 'app-add-edit-dynamic-data-definition',
  templateUrl: './add-edit-dynamic-data-definition.component.html',
  styleUrls: ['./add-edit-dynamic-data-definition.component.css']
})
export class AddEditDynamicDataDefinitionComponent implements OnInit {
  dataDefList: DataDefinitionList;
  dataDefId: number; // Primary Key Column Value
  dataDef: any;
  allDataDef: any;
  dataDefBindings: any;
  fields: DataDefinitionDynamicColumn[] = [];
  displayFields: DataDefinitionDynamicColumn[] = [];
  errors: ErrorList[] = [];
  dynamicFieldForm: FormGroup;
  minLengthErrorMessage: { key: string, errorMessage: string }[] = [];
  viewOnly = false;

  @ViewChildren('input') inputControls: QueryList<any>;

  constructor(
    private dialog: MatDialogRef<AddEditDynamicDataDefinitionComponent>
  ) { }

  ngOnInit() {
    this.displayFields = this.fields.filter(f => f.DisplayOnForm).sort((a, b) => a.FormSequence - b.FormSequence);
    this.viewOnly = (this.dataDefList.LockSystemCodes && this.dataDef.IsSysGen == true) ? true : false;
    this.dataDefId = this.dataDef[this.fields[0].ColumnName];
    this.dynamicFieldForm = new FormGroup({});
    this.displayFields.forEach(field => {
      const validators = this.setControlValidations(field);
      if (validators.length > 0) {
        this.dynamicFieldForm.addControl(field.ColumnName, new FormControl({ value: '', disabled: !field.Editable || this.viewOnly }, validators));
      } else {
        this.dynamicFieldForm.addControl(field.ColumnName, new FormControl({ value: '', disabled: !field.Editable || this.viewOnly }, null));
      }

      this.minLengthErrorMessage.push({ key: field.ColumnName, errorMessage: 'Required Field' });
    });

    this.onChanges();
  }

  onChanges(): void {
    this.dynamicFieldForm.valueChanges.subscribe(val => {
      Object.keys((<FormGroup>this.dynamicFieldForm).controls).forEach(key => {
        if (this.dynamicFieldForm.get(key).errors != null) {
          if (this.dynamicFieldForm.get(key).errors.hasOwnProperty('minlength')) {
            const requiredLength = this.dynamicFieldForm.get(key).errors.minlength.requiredLength;
            const errorMessage = ' Should be atleast ' + requiredLength + ' characters long';
            this.minLengthErrorMessage.filter(x => x.key === key)[0].errorMessage = errorMessage;
          }
        }
      });
    });
  }

  getErrorMessage(fieldName: string): string {
    return this.minLengthErrorMessage.filter(x => x.key === fieldName)[0].errorMessage;
  }

  getDataSource(fieldName: string): any {
    if (this.dataDefBindings.hasOwnProperty('length')) {
      for (let i = 0; i < this.dataDefBindings.length - 1; i++) {
        if (this.dataDefBindings[i].Field.FieldName === fieldName) {
          return this.dataDefBindings[i].Bindings;
        }
      }
    } else {
      if (this.dataDefBindings.Field.FieldName === fieldName) {
        return this.dataDefBindings.Bindings;
      }
    }
  }

  // add validation to control based on field setting
  setControlValidations(field: DataDefinitionDynamicColumn): ValidatorFn[] {
    const validators: ValidatorFn[] = [];
    if (field.Required) { validators.push(Validators.required); }
    if (field.MinLength) { validators.push(Validators.minLength(field.MinLength)); }

    return validators;
  }

  errorLinkClick(fieldName: string) {
    const control = this.inputControls.find(x => x.nativeElement.name == fieldName);
    if (control) {
      control.nativeElement.focus();
    }
  }

  validate() {
    this.errors = [];
    Object.keys((<FormGroup>this.dynamicFieldForm).controls).forEach(control => {
      this.dynamicFieldForm.get(control).markAsTouched();
      const field = this.displayFields.filter(x => x.ColumnName === control)[0];
      const fieldValue = this.dataDef[field.ColumnName] != null ? this.dataDef[field.ColumnName] : '';
      let codeExists = null;
      if (typeof fieldValue === 'string' && fieldValue.length > 0) {
        codeExists = this.allDataDef.find(o => (this.dataDefId == null || o[this.fields[0].ColumnName] != this.dataDefId) && o[field.ColumnName] != null && o[field.ColumnName].toUpperCase() == fieldValue.toUpperCase());
      }
      if (typeof fieldValue === 'boolean' || typeof fieldValue === 'number') {
        codeExists = this.allDataDef.find(o => (this.dataDefId == null || o[this.fields[0].ColumnName] != this.dataDefId) && o[field.ColumnName] != null && o[field.ColumnName] == fieldValue);
      }
      if ((field && field.Required) && (fieldValue.toString().trim().length === 0)) {
        this.errors.push({
          fieldName: field.DisplayName,
          fieldRef: null,
          errorMsg: 'is required.',
          clickCallback: () => {
            this.errorLinkClick(control);
          }
        });
      }
      if ((field && field.Required) && (codeExists)) {
        this.errors.push({
          fieldName: field.DisplayName,
          fieldRef: null,
          errorMsg: 'already exists.',
          clickCallback: () => {
            this.errorLinkClick(control);
          }
        });
      }
      if ((field && field.MinLength > 0) && (fieldValue.toString().trim().length < field.MinLength)) {
        this.errors.push({
          fieldName: field.DisplayName,
          fieldRef: null,
          errorMsg: field.DisplayName + ' must be at least ' + field.MinLength + ' characters.',
          clickCallback: () => {
            this.errorLinkClick(control);
          }
        });
      }
    });
  }

  saveClick() {
    this.validate();
    if (this.errors.length == 0) {
      this.dialog.close('save');
    }
  }

  cancelClick() {
    this.dialog.close('cancel');
  }
}
